import {gistApi} from '../_helpers'
import {requestHelper,responseHelper} from '../_helpers';

/**
 * This service adds the following functionality
 */
export const gistService = {
    getGist
};

/**
 * This method fetches the gist
 * @param uuid
 * @returns {Promise<never | never>}
 */
function getGist(uuid) {
    let myHeader = requestHelper.authHeader();
    let link = '/api/gists/'+uuid;

    return gistApi.get(link, {headers: myHeader})
        .then(response => {
            return responseHelper.handleResponse(response);
        })
        .then(gist => {
            return gist;
        })
        .catch(error => {
            return Promise.reject( responseHelper.handleError(error.response) );
        })
}
